export async function loadPdfjs() {
  if (window.pdfjsLib) return window.pdfjsLib;

  const pdfjsLib = await import("/vendor/pdfjs/pdf.mjs");
  pdfjsLib.GlobalWorkerOptions.workerSrc = "/vendor/pdfjs/pdf.worker.mjs";
  window.pdfjsLib = pdfjsLib;
  return pdfjsLib;
}

